export default __webpack_public_path__ + "static/media/img-0057-usa-full-face.c18f75e0.png";